var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-modal",
    { attrs: { title: _vm.modalTitle }, on: { close: _vm.dismiss } },
    [
      _c(
        "cms-form",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { "submit-button": "Opslaan", submitting: _vm.submitting },
          on: { submit: _vm.submit },
        },
        [
          _c("cms-form-date-picker", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: _vm.shouldValidateDate
                  ? "required|date_format:YYYY-MM-DD|before:" + _vm.beforeDate
                  : "required",
                expression:
                  "shouldValidateDate ? 'required|date_format:YYYY-MM-DD|before:' + beforeDate : 'required'",
              },
            ],
            attrs: {
              title: _vm.startDateTitle,
              name: "startDate",
              input: "true",
              "data-vv-as": "Start datum",
              error: _vm.error("startDate"),
            },
            model: {
              value: _vm.data.startDate,
              callback: function ($$v) {
                _vm.$set(_vm.data, "startDate", $$v)
              },
              expression: "data.startDate",
            },
          }),
          _vm.shouldShowEndDate
            ? _c("cms-form-date-picker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: _vm.endDateRules,
                    expression: "endDateRules",
                  },
                ],
                attrs: {
                  title: "(Verwachte) Eind datum",
                  name: "endDate",
                  input: "true",
                  "data-vv-as": "Eind datum",
                  error: _vm.error("endDate"),
                },
                model: {
                  value: _vm.data.endDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "endDate", $$v)
                  },
                  expression: "data.endDate",
                },
              })
            : _vm._e(),
          _vm.shouldShowReference
            ? _c("cms-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  title: "Referentie",
                  name: "reference",
                  "data-vv-as": "Referentie",
                  error: _vm.error("reference"),
                },
                model: {
                  value: _vm.data.reference,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "reference", $$v)
                  },
                  expression: "data.reference",
                },
              })
            : _vm._e(),
          _vm.shouldShowProject
            ? _c("cms-form-dropdown", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  title: "Project",
                  searchable: "true",
                  "max-height": "150",
                  options: _vm.projectOptions,
                  "data-vv-as": "Project",
                  "data-vv-name": "project",
                  error: _vm.error("project"),
                },
                model: {
                  value: _vm.data.projectId,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "projectId", $$v)
                  },
                  expression: "data.projectId",
                },
              })
            : _vm._e(),
          _vm.shouldShowReplacementLogger
            ? _c("cms-form-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'",
                  },
                ],
                attrs: {
                  title: "Vervangende logger",
                  hint: "Serienummer",
                  name: "replacementLoggerSerialNumber",
                  "data-vv-as": "Vervangende logger",
                  error: _vm.error("replacementLoggerSerialNumber"),
                },
                model: {
                  value: _vm.data.replacementLoggerSerialNumber,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "replacementLoggerSerialNumber", $$v)
                  },
                  expression: "data.replacementLoggerSerialNumber",
                },
              })
            : _vm._e(),
          !_vm.entries && _vm.action !== "REPAIR_ACTIVE"
            ? _c("cms-form-textarea", {
                attrs: { title: "Opmerkingen" },
                model: {
                  value: _vm.comments,
                  callback: function ($$v) {
                    _vm.comments = $$v
                  },
                  expression: "comments",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }